import "../styles.css";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Switch,
  Tooltip,
} from "@mui/material";
import { FC, useContext, useEffect, useState } from "react";
import SharedCard from "../../../../shared/components/sharedCard";
import useMutation from "../../../../shared/components/hooks/useMutation";
import useQuery from "../../../../shared/components/hooks/useQuery";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import Loader from "../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../shared/components/noPermissionBanner";
import { ProfileBorderBox } from "../../../../shared/components/profileComponents";
import { ViewContainer } from "../../../../shared/components/viewContainer";
import { FormContainer } from "../../../../shared/components/formContainer";
import useLazyQuery from "../../../../shared/components/hooks/useLazyQuery";
import { useFormik } from "formik";
import { customizeServiceValidationSchema } from "../variables/customSchema";
import { ZSAutocomplete } from "../../../../shared/components/autoComplete";
import CircularLoader from "../../../../shared/components/loader/circularProgress";
import NoData from "../../../../shared/components/noDataFoundBanner/images/no-data.svg";
import NoDataFound from "../../../../shared/components/noDataFoundBanner";

interface ActiveServiceProps {
  organizationId: string;
  entityPermissions: string[];
}

const ActiveService: FC<ActiveServiceProps> = ({ organizationId, entityPermissions }) => {
  const { modifyData } = useMutation();
  const [newServiceStatus, setNewServiceStatus] = useState(false);
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState<{
    [key: number]: boolean;
  }>({});
  const { payload } = useContext(SidebarContext);
  const { loading, data, fetchData, error } = useQuery(
    "/admin/organization-services",
    {
      params: {
        ...payload,
        organizationID: organizationId,
      },
    }
  );
  const { data: FeaturedData, fetchData: fetchFeaturedData } = useLazyQuery(
    `services/getFeaturedOrganizationServices/${organizationId}`
  );

  const resellerServiceData = (data as any)?.items || [];

  console.log("DATA", resellerServiceData);

  const handleStatusChange = async (organizationServiceId: number) => {
    setButtonLoading((prev) => ({ ...prev, [organizationServiceId]: true }));
    let response = await modifyData(
      `admin/organization-services/status-change/${organizationServiceId}`,
      "put"
    );
    if (response.status) fetchData();
    setButtonLoading((prev) => ({ ...prev, [organizationServiceId]: false }));
  };


  const closeAdminEdit = () => {
    setNewServiceStatus(false);
  };

  const handleChange = () => {
    setNewServiceStatus(true);
  };
  const titleBar = {
    title: "",
    headerTitle: "",
    buttonTitle: "New Services",
    disabled:  entityPermissions
    ? !entityPermissions?.includes("Reseller-Create")
    : false,
    onClick: () => handleChange(),
    subHeading: "",
    dirty: true,
  };
  useEffect(() => {
    if (newServiceStatus) {
      fetchFeaturedData();
    }
  }, [newServiceStatus]);

  const FeaturedServices = (FeaturedData as any)?.data || [];
  const service = FeaturedServices?.map((featuredService: any) => ({
    value: featuredService.id,
    label: featuredService.name,
  }));
  const initialValues: { serviceID: ""; resellerID: string } = {
    serviceID: "",
    resellerID: organizationId,
  };
  const featuredForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeServiceValidationSchema(),
    onSubmit: async (formData: any) => {
      setSaveButtonLoading(true);
      const updatedFormData = {
        ...formData,
        resellerID: parseInt(formData.resellerID),
        serviceID: parseInt(formData.serviceID),
        isReseller: true
      };
      let response = await modifyData(
        "admin/organization-services",
        "post",
        {
          ...updatedFormData,
        },
        featuredForm
      );
      setSaveButtonLoading(false);
      if (response) {
        featuredForm.resetForm();
        closeAdminEdit();
        fetchData();
      }
    },
  });

  console.log(featuredForm);
  return (
    <>
      <ProfileBorderBox>
        <ViewContainer loading={loading} titleBar={titleBar}>
          <>
            {loading && <Loader />}
            {(error as any)?.statusCode === 403 && <NoPermissionContent />}
            {resellerServiceData.length === 0 && <NoDataFound />}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                justifyContent: "flex-start",
                marginTop: 3,
                marginLeft: 2,
              }}
            >
              {!loading &&
                !error &&
                Array.isArray(resellerServiceData) &&
                resellerServiceData?.map((service: any, index: number) => (
                  <SharedCard
                    key={index}
                    icon={
                      <img
                        src={
                          service.service.iconUrl
                            ? service.service.iconUrl
                            : NoData
                        }
                        alt="Icon"
                        style={{
                          width: 55,
                          height: 55,
                          objectFit: "contain",
                          filter: service.isActive ? "none" : "grayscale(100%)",
                        }}
                      />
                    }
                    title={
                      service.isActive ? (
                        service.service.name
                      ) : (
                        <span style={{ color: "gray" }}>
                          {service.service.name}
                        </span>
                      )
                    }
                    action={
                      <Tooltip
                        title={
                          service.isActive
                            ? "Active - Click to deactivate"
                            : "Inactive - Click to activate"
                        }
                        arrow
                        placement="top"
                      >
                        <Switch
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#1b6c5c",
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "#1b6c5c",
                            },
                            "& .MuiSwitch-switchBase": {
                              color: "primary",
                            },
                            "& .MuiSwitch-track": {
                              backgroundColor: "primary",
                            },
                          }}
                          size="medium"
                          disabled={buttonLoading[service.id]}
                          checked={service.isActive}
                          onChange={() => handleStatusChange(service.id)}
                        />
                      </Tooltip>
                    }
                  />
                ))}{" "}
            </Box>
          </>
        </ViewContainer>
      </ProfileBorderBox>
      {newServiceStatus && (
        <Dialog
          open={newServiceStatus}
          onClose={closeAdminEdit}
          fullWidth
          maxWidth="md"
          PaperProps={{ style: { borderRadius: 16, padding: "32px" } }}
        >
          <DialogTitle>Featured Services</DialogTitle>
          <Divider />
          <DialogContent>
            <FormContainer>
              <Box className="form-border-custom">
                <Grid
                  container
                  alignItems="stretch"
                  columnSpacing={4}
                  rowSpacing={2}
                >
                  <Grid item md={12} sm={6} xs={12}>
                    <ZSAutocomplete
                      options={service}
                      placeholder="Select Service"
                      label="Services"
                      required
                      setValue={(selectedOption: any) => {
                        featuredForm.setFieldTouched("serviceID", true);
                        if (selectedOption?.value) {
                          featuredForm.setFieldValue(
                            "serviceID",
                            Number(selectedOption?.value)
                          );
                        } else {
                          featuredForm.setFieldValue("serviceID", "");
                        }
                      }}
                      setBlur={() => {
                        featuredForm.setFieldTouched("serviceID", true);
                      }}
                      form={{ ...featuredForm, name: "serviceID" }}
                    // refetchFunction={(searchString: string) => {
                    //   setPayload((prevData: any) => {
                    //     return { ...prevData, search: searchString };
                    //   });
                    // }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </FormContainer>
          </DialogContent>
          <DialogActions sx={{ px: 5 }}>
            <Button onClick={closeAdminEdit} color="warning" variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={() => featuredForm.handleSubmit()}
              color="primary"
              variant="contained"
              disabled={saveButtonLoading}
              startIcon={saveButtonLoading && <CircularLoader />}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default ActiveService;
